import { defaultConfig } from '../../../../../utils/config';

type StreamLogLevel = 'all' | 'basic' | null;
type StreamLogCategory = 'init' | 'wrap' | 'phase' | 'delta' | 'tool' | 'ctx' | 'prelude' | 'error' | 'warn' | 'debug';

const level: StreamLogLevel = (defaultConfig as any)?.CONSOLE_LOG_STREAM ?? null;

function isAllowed(category: StreamLogCategory): boolean {
  if (level === 'all') return true;
  if (level === 'basic') return category === 'init' || category === 'wrap';
  return false;
}

function logInternal(method: 'log' | 'warn' | 'error', category: StreamLogCategory, tag: string, ...args: any[]) {
  // Always allow warnings and errors regardless of config level
  if (method === 'log') {
    if (!isAllowed(category)) return;
  }
  try {
    // Use concise, tagged logs per user preference
    (console as any)[method](`[${tag}]`, ...args);
  } catch (_) {}
}

export const streamLog = {
  init: (...args: any[]) => logInternal('log', 'init', 'Stream', ...args),
  wrap: (...args: any[]) => logInternal('log', 'wrap', 'Stream', ...args),
  phase: (...args: any[]) => logInternal('log', 'phase', 'Stream', ...args),
  delta: (...args: any[]) => logInternal('log', 'delta', 'Stream', ...args),
  tool: (...args: any[]) => logInternal('log', 'tool', 'Stream', ...args),
  ctx: (...args: any[]) => logInternal('log', 'ctx', 'Stream', ...args),
  prelude: (...args: any[]) => logInternal('log', 'prelude', 'Stream', ...args),
  warn: (...args: any[]) => logInternal('warn', 'warn', 'Stream', ...args),
  error: (...args: any[]) => logInternal('error', 'error', 'Stream', ...args),
  debug: (...args: any[]) => logInternal('log', 'debug', 'Stream', ...args),
};


